import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import paperPlane from "assets/img/icons/spot-illustrations/paper-plane-osiris.png";
import paths from "routes/paths";

const ConfirmMailContent = ({ titleTag: TitleTag = "h4" }) => {
  const location = useLocation();
  const emailParams = new URLSearchParams(location.search);
  const email = emailParams.get("email"); // Récupère l'email de l'URL
  return (
    <>
      <img
        className="d-block mx-auto mb-4"
        src={paperPlane}
        alt="sent"
        width={100}
      />
      <TitleTag>Please check your email!</TitleTag>
      <p>
        An email has been sent to <strong>{email}</strong>. Please click on the
        included link to reset your password.
      </p>
      <Button
        as={Link}
        color="primary"
        size="sm"
        className="position-absolute bottom-0 end-0 m-5 d-none d-md-block"
        to={paths.login}
      >
        <FontAwesomeIcon
          icon="chevron-left"
          transform="shrink-4 down-1"
          className="me-1"
        />
        Return to login
      </Button>
    </>
  );
};

ConfirmMailContent.propTypes = {
  email: PropTypes.string.isRequired,
  layout: PropTypes.string,
  titleTag: PropTypes.string,
};

export default ConfirmMailContent;
